import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaFacturadoVendedor = ({desde, hasta, styles}) => {
    const tarjeta = "cardDashboard";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true);
    const [expandir, setExpandir] = useState(false);

    const getData = async (desde, hasta) => {
        setLoading(true);
        setExpandir(false);
        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&desde=${desde}&hasta=${hasta}&vendedor=1`);

        if (req.success) {
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
        getData(desde, hasta);
    }, [desde, hasta]);

    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    const dataCount = [data?.B01, data?.B02, data?.B14, data?.Proforma, data?.B15].filter(r => r).length;

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div className="color-primary" style={styles.principal}>
                        {formatCurrency(data?.totalFactura)}
                    </div>
                    <div style={styles.subtitulo}>
                        Facturado
                    </div>
                </div>

                <div style={{
                    ...styles.infoBlockContainer,
                    maxHeight: expandir ? '250px' : '80px'
                }} className="row">

                    {data?.B01 > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong><small className="badge badge-success">{data?.B01Count}</small> {formatCurrency(data.B01)}</strong>
                            </div>
                            <small style={styles.label}>Crédito Fiscal</small>
                        </div>
                    )}

                    {data?.B02 > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>
                                    <small className="badge badge-success">{data?.B02Count}</small> {formatCurrency(data.B02)}
                                </strong>
                            </div>
                            <small style={styles.label}>Consumidor Final</small>
                        </div>
                    )}

                    {data?.B14 > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>
                                    <small className="badge badge-success">{data?.B14Count}</small> {formatCurrency(data.B14)}
                                </strong>
                            </div>
                            <small style={styles.label}>Régimen Especial</small>
                        </div>
                    )}

                    {data?.Proforma > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>
                                    <small className="badge badge-success">{data?.ProformaCount}</small> {formatCurrency(data.Proforma)}
                                </strong>
                            </div>
                            <small style={styles.label}>Proforma</small>
                        </div>
                    )}

                    {data?.B15 > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>
                                    <small className="badge badge-success">{data?.B15Count}</small> {formatCurrency(data.B15)}
                                </strong>
                            </div>
                            <small style={styles.label}>Gubernamentales</small>
                        </div>
                    )}
                </div>
                {dataCount > 2 && !expandir && (
                    <button type="button" style={styles.expandir} onClick={() => setExpandir(true)}>Expandir</button>
                )}
            </div>
        </div>
    )
}

export default TarjetaFacturadoVendedor;
